module.exports = __webpack_public_path__ + "ad50063cf06625e57b119585ed337854.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-11.png
// module id = 1746
// module chunks = 0